import React, { useState } from 'react';

import { NotificationItem } from '@components/NotificationItem';
import { usePatchNotification } from '@hooks/mutation/usePatchNotification';
import { Notification } from '@models/Notification';
import { makeMuiStyles } from '@styles';
import { formatDateTime } from '@utils/types';

const useStyles = makeMuiStyles((theme, common) => ({
  contentBox: {
    ...common.normalText,
    fontSize: 14,
    backgroundColor: theme.palette.base[200],
    transition: '0.2s',
    whiteSpace: 'pre-line',
    padding: '1.25rem',
    paddingTop: 0,
  },
  content: {
    '& a': {
      color: theme.palette.primary.main,
      textDecoration: 'underline',
      textUnderlineOffset: `2px`,
    },
    '& span': {
      color: theme.palette.primary.main,
    },
  },
}));

export interface NotificationItemProps {
  index: number;
  notification: Notification;
}

export const NotificationCenterItem: React.FC<React.PropsWithChildren<NotificationItemProps>> = (
  props,
) => {
  const classes = useStyles();

  const { notification } = props;

  const [toggleState, setToggleState] = useState(false);
  const patchNotification = usePatchNotification();
  const updateNotice = async () => {
    setToggleState(!toggleState);
    if (!notification.has_read) {
      await patchNotification.mutateAsync(notification?.id);
    }
  };

  return (
    <NotificationItem
      title={notification.title}
      date={formatDateTime(notification.created_at)}
      onRead={updateNotice}
      hasRead={notification.has_read}
    >
      <div className={classes.contentBox}>
        <div
          className={classes.content}
          dangerouslySetInnerHTML={{ __html: notification.content }}
        />
      </div>
    </NotificationItem>
  );
};
